import React, { FC } from "react"
import styled from "styled-components"

import SocialShare, {
  SOCIAL_SHARE_DIRECTION,
} from "@components/SocialShare/SocialShare"

import { MEDIA_QUERIES } from "@constants"

const SocialShareCalloutContainerDIV = styled.div`
  background: var(--color--slate-100);
  border-radius: var(--border-radius--S);
  color: #292f33;
  padding: 15px;
  margin-bottom: var(--spacing--S);
  width: 100%;

  ul {
    margin-bottom: 0;
  }

  h6 {
    color: inherit;
    margin: 0 auto var(--spacing--S) auto;
    width: 160px;
    text-align: center;
    font-weight: 500;
  }

  ${MEDIA_QUERIES.M} {
    max-width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-left: 30px;

    ul {
      margin: 0;
      position: relative;
      display: flex;
      flex: 0 0 auto;
      top: unset;
    }

    h6 {
      width: 100%;
      flex: 1;
      margin: 0;
      text-align: left;
    }
  }
`

type SocialShareProps = {
  title: string
  url: string
}

const SocialShareCallout: FC<SocialShareProps> = ({ title, url }) => (
  <SocialShareCalloutContainerDIV>
    <h6 className="type--headline-medium-M">
      Like what you see? Share with a friend.
    </h6>
    <SocialShare
      direction={SOCIAL_SHARE_DIRECTION.HORIZONTAL}
      title={title}
      url={url}
    />
  </SocialShareCalloutContainerDIV>
)

export default SocialShareCallout
